const koraxTokens = {
  colors: {
    primary: "#155EEF",
    primaryHover: "#004EEB",
    primaryActive: "#003BB8",
    primarySoft: "#EFF4FF",
    primaryBorder: "#B2CCFF",

    secondary: "#0BA5EC",

    background: "#F5F7FB",
    backgroundDark: "#07101F",

    surface: "#FFFFFF",
    surfaceSoft: "#F8FAFC",
    surfaceMuted: "#F2F4F7",
    surfaceDark: "#101828",

    textPrimary: "#101828",
    textSecondary: "#475467",
    textMuted: "#667085",
    textDisabled: "#98A2B3",
    textInverse: "#FFFFFF",

    border: "#E4E7EC",
    borderStrong: "#D0D5DD",
    borderDark: "#344054",

    sidebar: "#0C152B",
    sidebarDeep: "#081126",
    sidebarSurface: "#102A56",
    sidebarText: "#C8D3E8",
    sidebarTextMuted: "#94A3B8",

    success: "#12B76A",
    successSoft: "#ECFDF3",

    warning: "#F79009",
    warningSoft: "#FFFAEB",

    error: "#F04438",
    errorSoft: "#FEF3F2",

    info: "#0BA5EC",
    infoSoft: "#F0F9FF"
  },

  spacing: {
    xxs: 4,
    xs: 8,
    sm: 12,
    md: 16,
    lg: 20,
    xl: 24,
    xxl: 32,
    xxxl: 40
  },

  radius: {
    xs: 6,
    sm: 8,
    md: 10,
    lg: 12,
    xl: 16,
    xxl: 20,
    pill: 999
  },

  shadows: {
    xs: "0 1px 2px rgba(16, 24, 40, 0.05)",
    sm: "0 2px 8px rgba(16, 24, 40, 0.06)",
    md: "0 6px 18px rgba(16, 24, 40, 0.08)",
    lg: "0 14px 36px rgba(16, 24, 40, 0.12)",
    focus: "0 0 0 3px rgba(21, 94, 239, 0.14)"
  },

  typography: {
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",

    pageTitleSize: 24,
    pageTitleWeight: 700,

    sectionTitleSize: 18,
    sectionTitleWeight: 700,

    bodySize: 14,
    bodyWeight: 400,

    labelSize: 13,
    labelWeight: 600,

    captionSize: 12
  },

  layout: {
    topbarHeight: 64,
    topbarHeightMobile: 56,

    sidebarWidth: 240,
    sidebarCollapsedWidth: 72,

    contentMaxWidth: 1600,
    contentPaddingDesktop: 24,
    contentPaddingTablet: 20,
    contentPaddingMobile: 12,

    pageHeaderMinHeight: 48
  },

  transitions: {
    fast: "all 0.15s ease",
    normal: "all 0.2s ease",
    slow: "all 0.3s ease"
  }
};

export default koraxTokens;
